<template>
  <VaDropdown class="color-dropdown" :offset="[13, 0]" position="bottom">
    <template #anchor>
      <VaIconColor />
    </template>

    <VaDropdownContent class="color-dropdown__content pl-4 pr-4 pt-2 pb-2">
      <VaButtonToggle v-model="theme" color="background-element" border-color="background-element" :options="options" />
    </VaDropdownContent>
  </VaDropdown>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import VaIconColor from '../../../icons/VaIconColor.vue'
import { useI18n } from 'vue-i18n'
import { useColors } from 'vuestic-ui'

const { applyPreset, currentPresetName } = useColors()

const theme = computed({
  get() {
    return currentPresetName.value
  },
  set(value) {
    applyPreset(value)
  },
})

const { t } = useI18n()

const options = [
  { label: t('buttonSelect.dark'), value: 'dark' },
  { label: t('buttonSelect.light'), value: 'light' },
]
</script>

<style lang="scss" scoped>
.color-dropdown {
  cursor: pointer;

  &__icon {
    position: relative;
    display: flex;
    align-items: center;
  }

  .va-dropdown__anchor {
    display: inline-block;
  }

  &__toggle {
    width: 100%;
    display: flex;
    justify-content: stretch;
  }
}

.button-restore {
  display: flex;
  margin: 0.375rem auto;
}

table {
  margin: 1rem 0;
}
</style>
